export default {
    common: {
        add: 'Добавить',
        no_data: 'Нет данных для отображения',
        email: 'Электронная почта',
        fullName: 'Фамилия Имя Отчество',
        login: 'Логин',
        general: 'Информация',
        headquarters: 'Головной офис',
        comment: 'Комментарий',
        attachments: 'Документы',
        citizenship: 'Гражданство',
        male: 'Мужской',
        female: 'Женский',
        sex: 'Пол',
        age: 'Возраст',
        languages: 'Иностранные языки',
        city: 'Город',
        language_level: {
            32: 'Средний',
            16: 'Базовый',
            8: 'Читаю проф. лит.',
            4: 'Разговорный',
            2: 'Свободный'
        },
        any: 'Не имеет значения',
        lessThanDay: 'Меньше дня',
        ago: 'назад',
        showPopover: 'Показать все строки',
        refresh: 'Обновить',
        yes: 'Да',
        no: 'Нет'
    },
    company: {
        phone: 'Телефон',
        address: 'Адрес',
        tags: 'Метки'
    },
    classifier: 'Классификатор',
    modal_settings: {
        save: 'Сохранить',
        cancel: 'Закрыть',
        default: 'По умолчанию'
    }
};
